import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { activeCatalogSelector } from '@vi-succ/products-domain';
import { combineLatest, first, switchMap } from 'rxjs';
import { selectUserContextInfo } from '../core/login/state';
import { environment } from '../environments/environment';
import { Feedback } from '../shared/feedback/feedback-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class EtFeedbackService {
  constructor(private http: HttpClient, private store: Store) {}

  sendFeedback(feedback: Feedback) {
    return combineLatest([
      this.store.select(selectUserContextInfo).pipe(first()),
      this.store.select(activeCatalogSelector).pipe(first()),
    ]).pipe(
      switchMap(([contextInfo, catalog]) => {
        const additionalData: { [key: string]: string } = {};
        if (contextInfo) {
          for (const [key, value] of Object.entries(contextInfo)) {
            if (typeof value === 'string' && value?.length > 0) {
              additionalData[key] = value;
            }
          }
        }
        if (catalog) {
          additionalData['current catalog language'] = catalog.language;
          additionalData['current catalog salesorg'] = catalog.salesOrg;
        }

        const formData = new FormData();

        feedback.files.forEach((file) => {
          formData.append('files[]', file.blob ?? new Blob(), file.name);
        });

        feedback.files = [];

        formData.append(
          'feedback',
          new Blob([JSON.stringify(feedback)], {
            type: 'application/json',
          })
        );

        return this.http.post<void>(`${environment.backend.url}/feedback`, formData);
      })
    );
  }
}
